import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Avatar from '@mui/material/Avatar';
import {
  useTheme,
  useMediaQuery,
  Button,
  Typography
} from '@mui/material';
import './index.css';
import { API_URL } from './tools/consts';

export default function ScorePage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { score } = useParams();
  const { pseudo } = useParams();
  const [listPlayers, setListPlayers] = useState([]);
  const [rank, setRank] = useState();
  const [rankText, setRankText] = useState();
  const navigate = useNavigate();

  const getTextFromRank = async (rank) => {
    let textRank = "";
    console.log(rank);
    switch (rank) {
      case '1':
        textRank = "première";
        break;
      case '2':
        textRank = "deuxième";
        break;
      case '3':
        textRank = "troisième";
        break;
      default:
        textRank = rank + "e";
    }
  }

  const rankingModal = withReactContent(Swal);

  const showAdModal = (pseudo) => {
    rankingModal.fire({
      title: `Bien joué... pour un début`,
      text: "Découvre le jeu de société L'Orange de Noël sur le stand ou en agences du Crédit Agricole ! ",
      imageUrl: "https://media.tenor.com/uov4Py6L-OYAAAAi/confeti.gif",
      background: "https://media.tenor.com/uov4Py6L-OYAAAAi/confeti.gif",
      // confirmButtonText: "Suivant",
      allowOutsideClick: false,
    }).then((res) => {
      // if (res.isConfirmed) {
      //   rankingModal.close();
      // }
    });
  };

  const getRank = async (score) => {
    const rank = await fetch(API_URL + "players/rank/" + score, {
      method: "GET",
    });
    const json = await rank.json();
    console.log(json.rank);
    setRank(json.rank);
  }

  const getScorePoints = async () => {
    const qr = await fetch(API_URL + "players/bests", {
      method: "GET",
      // credentials: "include"
    });
    const json = await qr.json();
    const playersArray = Object.values(json);
    setListPlayers(playersArray);
    console.log(playersArray);
  };

  const eraseNameAndReplay = async (pseudo) => {
    const qr = await fetch(API_URL + "players/delete_one/" + pseudo, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: pseudo,
      }),
    }).then(() => {
      navigate('/jeu', { state: { pseudo, firstTry: false } });
    })
  }

  useEffect(() => {
    showAdModal(pseudo);
  }, []);

  useEffect(() => {
    const fetchRank = async () => {
      await getRank(score);
    };

    fetchRank();
  }, [score]);

  useEffect(() => {
    const fetchTextRank = async () => {
      getTextFromRank(rank);
    };

    fetchTextRank();
  }, [rank]);

  useEffect(() => {
    const showRanks = async () => {
      // showRankingModal(pseudo, rank, rankText);
      await getScorePoints();
    }
    showRanks();

  }, [rankText]);
  return (
    <div
      style={{
        backgroundImage: `url('/Couverture.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        position: 'relative',
      }}
    >
      <div class="header">
        <img src='/logo_o.png' alt='' style={{ height: '20vh', position: 'relative', top: '-2.5em' }} />
      </div>

      <div class="content">

      </div>

      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: 'rgba(255, 255, 255, 0.8)'
      }}>
        {/* <Typography align="center" variant='h4' style={{ marginBottom: '20px' }}>{pseudo}</Typography> */}

        {/* <Typography align="center" variant='h5'>Tu es à la place numéro {rank} avec {score} points !</Typography> */}
        <Typography align="center" variant='h5'>Ton score : {score} points </Typography>
        {/* <img src='/trophee.png' alt='medaille' style={{ width: '10vh', textAlign: 'center' }} /> */}

      </div>
      <div style={{
        borderRadius: '10px',
        padding: '10px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '10px',
        width: '90%',
        maxWidth: '600px',
        marginBottom: '5vh'
      }}>
        {listPlayers.map((player, index) => (
          <Card
            key={player.id}
            style={{
              width: '100%',
              height: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '10px 20px',
              backgroundColor: index % 2 === 0 ? '#f0f0f0' : '#e0e0e0',
              border: '1px solid #ccc',
              borderRadius: '10px',
            }}
          >
            <CardHeader
              avatar={
                index === 0 ? (
                  <Avatar sx={{ bgcolor: '#FFD700' }}>
                    {index + 1}
                  </Avatar>
                ) : index === 1 ? (
                  <Avatar sx={{ bgcolor: '#C0C0C0' }}>
                    {index + 1}
                  </Avatar>
                ) : index === 2 ? (
                  <Avatar sx={{ bgcolor: '#cd7f32' }}>
                    {index + 1}
                  </Avatar>
                ) : (
                  <Avatar sx={{ bgcolor: '#1976d2' }}>
                    {index + 1}
                  </Avatar>
                )
              }
              title={<Typography variant="h6">{player.username}</Typography>}
            />
            <CardContent>
              <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                {player.points} points
              </Typography>
            </CardContent>
          </Card>
        ))}
      </div>
      <div class="actions" style={{
        display: 'flex',
        gap: '10px'
      }}>
        <Button onClick={() => navigate('/')} variant='contained' color='error' style={{ marginBottom: '10vh' }}>Retour à l'accueil</Button>
        <Button onClick={() => eraseNameAndReplay(pseudo)} variant='contained' color='success' style={{ marginBottom: '10vh' }}>Rejouer</Button>
      </div>

      <a target="_blank" href="https://www.credit-agricole.com/notre-groupe/le-projet-societal-du-groupe-credit-agricole"> <img src='/Crédit_Agricole.svg.png' alt='logo' style={{ position: 'absolute', bottom: '30px', left: '8px', width: '15%' }} /> </a>
      <a target="_blank" href="https://potamgames.com/lorange-de-noel/"><img src='/logo.png' alt='logo' style={{ position: 'absolute', bottom: '10px', right: '5px', width: '15%' }} /> </a>

    </div>
  );
}
